import React from 'react'
import './Timeline.css'
import Question from './Question'

function Timeline (props) {
    const indices = [...Array(props.count).keys()]
    const interleave = (arr, thing) => [].concat(
        ...arr.map((n, i) => [n, thing(i)])).slice(0, -1)

    const currentClass = i => i === props.current ? 'current' : ''
    const futureClass = i => i > props.current ? 'future' : ''
    const availClass = i => props.available.includes(i) ? 'available' : ''

    const classes = i => `${currentClass(i)} ${futureClass(i)} ${availClass(i)}`

    return (
        <div className={'Timeline-container'}>
            {interleave(indices.map(i => (
                <div key={i}
                     className={'dot ' + classes(i)}
                     onClick={() => props.onSelect(i)}></div>
            )), afterIndex => (
                <div key={`after-${afterIndex}`}
                     className={'dash ' + classes(afterIndex + 1)}></div>
            ))}
        </div>
    )
}

export default Timeline
